import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import PercentageCorrect from './PercentageCorrect'

const useStyles = makeStyles({
    title: {
        color: '#4D4F5C',
        fontSize: 40,
        textAlign: 'center'
    },
    subtitle: {
        color: '#4D4F5C',
        fontSize: 16
    },
    date: {
        color: '#4D4F5C',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 5
    }
})

const ScoreBox = styled.div`
    width: 100%;
    background-color: #f2f2f2;
    padding: 24px 0 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px 6px 0 0
`

const FinalScore = styled.span`
    font-size: 40px;
    font-weight: bolder;
    color: #4415e4
`

const ExamScore = ({ acertos, score, correct, total, name, date }) => {
    const classes = useStyles()

    return (
        <ScoreBox>
            <Typography variant="h2" component="h2" className={classes.title}>
                {name}, sua nota foi <FinalScore>{score}</FinalScore>
            </Typography>
            <Typography variant="h4" component="h4" className={classes.subtitle}>
                {`Você acertou ${correct} de ${total} questões`}
            </Typography>
            <Typography variant="h4" component="h4" className={classes.date}>
                {date}
            </Typography>


            <PercentageCorrect acertos={acertos} />
        </ScoreBox>
    )
}

export default ExamScore